import { render } from "./ClipboardPlus.vue?vue&type=template&id=2bcc4af8"
import script from "./ClipboardPlus.vue?vue&type=script&lang=js"
export * from "./ClipboardPlus.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/ClipboardPlus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2bcc4af8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2bcc4af8', __exports__)) {
    api.reload('2bcc4af8', __exports__)
  }
  
  module.hot.accept("./ClipboardPlus.vue?vue&type=template&id=2bcc4af8", () => {
    api.rerender('2bcc4af8', render)
  })

}


export default __exports__